import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormCommonModule } from '@x/common/form';
import { IconModule } from '@x/common/icon';
import { SearchInputComponent } from '@x/ecommerce-shop/app/core/search/search-input/search-input.component';
import { RecentSearchesService } from '@x/ecommerce-shop/app/core/search/services/recent-searches.service';
import { SearchService } from '@x/ecommerce-shop/app/core/search/services/search.service';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { OverlayUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/overlay/overlay-ui.module';
import { InputLoaderModule } from 'apps/ecommerce-shop/src/app/core/shop-ui/components/input-loader';
import { SearchButtonComponent } from './search-button/search-button.component';

@NgModule({
  providers: [RecentSearchesService, SearchService],
  declarations: [SearchButtonComponent, SearchInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    A11yModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
    OverlayUiModule,
    OverlayModule,
    FontAwesomeModule,
    CloseButtonModule,
    IconModule,
    FormCommonModule,
    MatAutocompleteModule,
    InputLoaderModule,
    IconUiModule,
  ],
  exports: [SearchButtonComponent, SearchInputComponent],
})
export class SearchModule {}
